var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F3AF00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.603v3.74M12 17.707c.383 0 .693-.28.693-.624s-.31-.623-.693-.623c-.383 0-.693.28-.693.623 0 .345.31.624.693.624z",
    stroke: "#694C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.233 4.678a1.31 1.31 0 00-.51-.495A1.502 1.502 0 0012 4c-.255 0-.505.063-.723.183a1.31 1.31 0 00-.51.495L3.148 18.392a1.144 1.144 0 00.057 1.214c.123.18.296.33.502.434.206.105.438.16.674.16H19.62c.236 0 .468-.055.674-.16.206-.104.379-.253.502-.434a1.143 1.143 0 00.056-1.213L13.234 4.677z",
    stroke: "#694C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgWarningTriangule;